import { all, put, select, takeLatest } from 'redux-saga/effects';
import { RANGE_FILTER, } from '@as-react/common-types';
import { isNullOrUndefined, isMultiSelectFilter, isRangeFilter, isBucketFilter, isLinkFilter, } from '@as-react/common-utils';
import { isAxiosError } from 'axios';
import { filterActions } from '../actions/FilterActions.creators';
import { compareArraysOfObjectsAndReturnDuplicates, compareArraysOfObjectsAndReturnUniques, } from '../../../util/GeneralUtil';
import { listerActions } from '../../lister/actions/ListerActions.creators';
import { Logger } from '@as-react/logger';
import { UrlActionTypes } from '../../../enums/ActionEnums';
export function* updatePageAndFetchProductsSaga() {
    yield takeLatest(UrlActionTypes.UPDATE_FILTERS, updateMultiSelectFilter);
}
export const getActiveFilters = (state) => state.filters.activeFilters;
export const getListerFilters = (state) => state.lister.filters;
const checkIfFilterOnExists = (currentActiveFilters, filterOn) => !isNullOrUndefined(currentActiveFilters) && !isNullOrUndefined(currentActiveFilters[filterOn]);
const shouldRemoveLinkFilter = (currentActiveFilters, setFilterObject) => currentActiveFilters[setFilterObject.filterOn].values[0].filterKey === setFilterObject.filteredItems[0].filterKey;
export function* updateMultiSelectFilter(action) {
    try {
        yield put(listerActions.showPlaceholderTiles());
        let filteredItems = action.payload.filteredItems;
        let existingFilterKeys = [];
        if (action.payload.filterType === RANGE_FILTER) {
            const listerFilters = yield select(getListerFilters);
            const { rangeMin, rangeMax, boundaryMax, boundaryMin } = listerFilters.find(filter => filter.type === action.payload.filterType && filter.filterOn === action.payload.filterOn);
            if (Math.ceil(rangeMax) === boundaryMax && Math.floor(rangeMin) === boundaryMin) {
                yield put(filterActions.removeFilterObject({
                    filterOn: action.payload.filterOn,
                }));
                return;
            }
        }
        if (isMultiSelectFilter(action.payload) || isBucketFilter(action.payload)) {
            const currentActiveFilters = yield select(getActiveFilters);
            if (action.payload.multiUpdate) {
                filteredItems = filteredItems.filter((item) => item.isActive);
            }
            else if (checkIfFilterOnExists(currentActiveFilters, action.payload.filterOn)) {
                const currentFilterKeys = currentActiveFilters[action.payload.filterOn].values;
                existingFilterKeys = (compareArraysOfObjectsAndReturnDuplicates(currentFilterKeys, filteredItems, 'filterKey'));
                filteredItems = [
                    ...(compareArraysOfObjectsAndReturnUniques(existingFilterKeys, currentFilterKeys, 'filterKey')),
                    ...(compareArraysOfObjectsAndReturnUniques(existingFilterKeys, filteredItems, 'filterKey')),
                ];
            }
        }
        else if (isRangeFilter(action.payload)) {
            if (action.payload.isReset) {
                filteredItems = [];
            }
        }
        else if (isLinkFilter(action.payload)) {
            const activeFilters = yield select(getActiveFilters);
            if (checkIfFilterOnExists(activeFilters, action.payload.filterOn) &&
                shouldRemoveLinkFilter(activeFilters, action.payload)) {
                filteredItems = [];
            }
        }
        if (filteredItems.length > 0) {
            yield put(filterActions.setFilterObject({
                filteredItems,
                filterOn: action.payload.filterOn,
                filterOnName: action.payload.filterOnName,
                filterType: action.payload.filterType,
                filterDisplayHint: action.payload.filterDisplayHint,
                filterPrefix: action.payload.filterPrefix,
                filterSuffix: action.payload.filterSuffix,
                filterContentType: action.payload.filterContentType,
                queryParamKey: action.payload.queryParamKey,
            }));
        }
        else {
            yield put(filterActions.removeFilterObject({
                filterOn: action.payload.filterOn,
                queryParamKey: action.payload.queryParamKey,
            }));
        }
    }
    catch (error) {
        if (!isAxiosError(error)) {
            Logger.logError(error);
        }
    }
}
export default function* filterSaga() {
    yield all([updatePageAndFetchProductsSaga()]);
}
